import React, { useCallback } from 'react';
import { ICustomAddButtonProps } from '../../../../_Common/Const/Delsystem';
import { BusinessCollectionMenuItem } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionMenu/Components/BusinessCollectionMenuItem';

const OversiktRapporterAddButton: React.FC<ICustomAddButtonProps> = ({
  setNewObject,
  expanded,
  renderButton,
}) => {
  const onClick = useCallback(() => {
    setNewObject?.(undefined, { initialPage: '1' });
  }, [setNewObject]);

  if (renderButton) {
    return renderButton({
      onClick: () => onClick(),
      icon: 'add',
      label: 'Skapa ny',
    }) as React.ReactElement;
  }

  return (
    <BusinessCollectionMenuItem
      expanded={expanded}
      icon="add"
      onClick={onClick}
      tooltip={'Skapa ny'}
      testId="OversiktRapporterAddButton_Add"
    />
  );
};

export default OversiktRapporterAddButton;
